import { Campus } from '@/modules/core/data/types/Campus';
import { EducationalProgramStep } from '@/modules/core/data/types/EducationalProgramStep';
import { ReactSelectRefLabelOption } from '@/modules/core/reactSelect/types/ReactSelect';
import find from 'lodash.find';
import map from 'lodash.map';

/**
 * Converts a list of campuses to a React-Select list of options.
 *
 * @param campuses
 */
export const convertCampusesAsSelectOptions = (campuses: Campus[]): ReactSelectRefLabelOption[] => {
  return map(campuses, (campus: Campus) => {
    return {
      ref: campus.ref,
      label: campus.label,
    };
  });
};

/**
 * Filters campuses based on the selected program steps.
 *
 * Only keeps campuses that are specified in the selected program steps.
 * If no campus is configured for any of the selected program steps, then returns all available campuses because that implies the program steps are available in all campuses.
 *
 * @param allCampuses
 * @param allEducationalProgramSteps
 * @param selectedEducationalProgramStepChoices
 */
export const filterCampusesByProgramSteps = (allCampuses: Campus[], allEducationalProgramSteps: EducationalProgramStep[], selectedEducationalProgramStepChoices: Pick<EducationalProgramStep, 'ref'>[]): Campus[] => {
  let allowedCampuses: Campus[] = [];

  if (!selectedEducationalProgramStepChoices) {
    allowedCampuses = allCampuses;
  } else {
    // For each selected program step, append its campuses to the array of allowed campuses
    map(selectedEducationalProgramStepChoices, (selectedEducationalProgramStep: Pick<EducationalProgramStep, 'ref'>) => {
      const programStep: EducationalProgramStep = find(allEducationalProgramSteps, (step: EducationalProgramStep) => {
        return step?.ref === selectedEducationalProgramStep?.ref;
      });
      const selectedEducationalProgramStepCampuses: Campus[] = programStep?.campuses || [];

      allowedCampuses = [
        ...allowedCampuses,
        ...selectedEducationalProgramStepCampuses,
      ];
    });

    // Handle edge case, if no campus passed the filter, it means there was no filter and all campuses should be allowed in this case
    if (allowedCampuses?.length === 0) {
      allowedCampuses = allCampuses;
    }
  }

  return allowedCampuses;
};
